const welcome = [
	<span><span style={{ color: '#AA0000' }}>Welcome back</span>, oh democracy lord</span>,
]

const message = [
	`local prison emptied, judge says "the inmates had to be delivered"`,
	`Comedian Cancels tour, fan says he couldn't deliver up to the expectations`,
	`Surveys reveals that democracy is now more popular than pizza`,
	`New decree renames Friday into FreeDay`,
	`Flash news: Antarctica adopts democracy`,
	`Flash news: Hell adopts democracy and vote Satan’s out`,
	`Historians discovered that Buddha was in reality preaching for democracy`,
	`Angry mustached man calls to arms against economical system in place`,
	`“I lost a leg and my right eye but I suppose they just wanted to do secession”`,
	`New law requires free sample to be delivered by pairs so they don’t feel alone`,
	`Experts worried mentions “There’s so much freedom that it might loose its meaning”`,
	`Delivery mans gifted a holyday worldwide`,
	`“mhmfmff nmpff ffu fmm” - Man eating liberty fries`,
	`Libertinism is now the most common way of living`,
	`A cat becomes president of a G12 country for the first time thanks to democracy`,
	`"Democracy" and "Freedom" were added as products by Amazin, Ubor and Wush`,
	`A seer predicts that democracy is humanity's only hope`,
	`After being ghosted by your friends, you decide to have a book on democracy delivered to them`,
	`“Democracy is cool but I can’t play league of heroes with it” Lee Fakr Sang-Hyook`,
	`Democracy will never give you up, let you down, let you cry, say goodbye, tell a lie or hurt you`,
	`“This is Dom. Free Dom”`,
	`“I see people who are free”`,
	`"Gee Bwain, what are we gonna do tonight?” “The same thing we do every night, try to take over the world!"`,
	`“Set us free and lead us not into temptation, but deliver us from evil, oh great overlord of democracy” - sing the delivered`,
	`My... precious... liberty...`,
	`You have come to fight as free men, and free men you are. What would you do with that freedom?`,
	`New study shows that democracy as reduced global warming drastically`,
	`“A new plot to bring us to a false liberty!” - some poor ignorant soul`,
	`Skydiving instructor makes a petition against the rename of the discipline in “’Free’ diving”`,
]

function randomInt(min, max) {
	return Math.floor(Math.random() * (max - min) + min)
}

export function randomWelcome(first) {
	if (first)
		return <span><span style={{ color: '#AA0000' }}>Welcome</span>, oh democracy lord</span>
	const index = randomInt(0, welcome.length - 1)
	return welcome[index]
}

export function randomMessage() {
	if (randomInt(0, 600) === 0) {
		const index = randomInt(0, message.length - 1)
		return message[index]
	}
	return null
}